<template>
  <v-container fluid>
    <v-select
      v-model="fase"
      clearable
      outlined
      return-object
      hide-details
      item-text="nombre"
      :items="items"
      label="Fase"
      dense
    ></v-select>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        fase: null,
        items: [
          { id: 2, nombre: 'NO APROBADO' },
          { id: 3, nombre: 'Inscripciones' },
          { id: 11, nombre: 'En Desarrollo' },
          { id: 4, nombre: 'Concluido' },
          { id: 5, nombre: 'ELABORACION TRABAJOS FINALES' },
          { id: 6, nombre: 'RECEPCION DE REQUISITOS DE TITULACION' },
          { id: 7, nombre: 'ARMADO CARPETAS' },
          { id: 8, nombre: 'PAGO ARANCELES' },
          { id: 9, nombre: 'PROCESO TITULACION' },
          { id: 10, nombre: 'CERTIFICADOS ENTREGADOS' },
        ],
      };
    },
    watch: {
      fase(newValue) {
        this.$emit('change', newValue);
      },
    },
  };
</script>

<style></style>
